import { everest } from '~/services/serviceInstances';

export const publishWorkflow = async ({ id }: { id: string }) => {
  return await everest.patch(`/workflows/${id}/publish`);
};
